import "./style";
import App from "./components/app";

import "./components/i18n";

export default App;
